import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Box, Stack, Link, IconButton} from 'views/components';
import {Translate} from 'views/module';
import {ArrowDropDown, ArrowDropUp} from 'views/icons';

const ServiceDetail = (props) => {
  const options = props.options;

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'navbar.main',
          py: '8px',
          pointerEvents: 'auto',
          width: '200px',
          pl: '16px',
        }}
      >
        {
          options.map((button, index) => {
            return (
              <Link
                href={button.link}
                style={{
                }}
                key={index}
              >
                <Typography
                  sx={{
                    'color': 'white',
                    'py': '16px',
                    'pl': '16px',
                    '&:hover': {
                      'textDecorationColor': '#FFFFFF',
                      'textDecorationThickness': '2px',
                      'textDecorationLine': 'underline',
                    },
                  }}
                >
                  <Translate expression={button.title} />
                </Typography>
              </Link>
            );
          })
        }
      </Box>
    </>
  );
};
ServiceDetail.propTypes = {
  options: PropTypes.array,
};

const NavbarService = (props) => {
  const title = props.title;
  const link = props.link;
  const options = props.options;
  const selected = props.selected;
  const serviceName = props.serviceName;
  const expand = props.expand;
  const setExpand = props.setExpand;


  let sx = {};
  if (selected) {
    sx = {
      'textDecorationColor': '#FFFFFF',
      'textUnderlineOffset': '4px',
      'textDecorationThickness': '2px',
      'textDecorationLine': 'underline',
      'filter': null,
    };
  } else if (expand) {
    sx = {
      'textDecorationColor': '#FFFFFF',
      'textUnderlineOffset': '4px',
      'textDecorationThickness': '2px',
      'textDecorationLine': 'underline',
      'filter': null,
    };
  }

  return (
    <Box>
      <Stack
        direction='row'
        alignItems="center"
        sx={{
        }}
      >
        <IconButton
          color="primary"
          component="span"
          size="large"
          onClick={() => setExpand((e) => e === serviceName ? null : serviceName)}
        >
          {
          expand ?
          <ArrowDropUp
            style={{color: 'white'}}
          /> :
          <ArrowDropDown
            style={{color: 'white'}}
          />
          }
        </IconButton>
        <Link
          href={link}
          style={{
            'textDecorationLine': 'none',
            'display': 'inline-block',
            'filter': 'contrast(25%)',
            ...sx,
          }}
        >
          <Typography variant='h5'
            sx={{
              color: 'white',
              fontWeight: selected ? 500 : 400,
              fontSize: '16px',
            }}>
            <Translate expression={title} />
          </Typography>
        </Link>
      </Stack>
      {
        expand &&
        <ServiceDetail
          options={options}
        />
      }
    </Box>
  );
};
NavbarService.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.bool,
  serviceName: PropTypes.string,
  expand: PropTypes.bool,
  setExpand: PropTypes.func,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarService));
